import { call, put, takeLatest, fork, all } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import { PATHS } from '../constants/Define';
import * as GroupActions from '../actions/groupAction';
import * as GroupService from './../services/groupService';
import Group from '../models/Group';
import history from '../helpers/history';


function* getListGroup() {
    yield takeLatest(Types.GROUP_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(GroupService.getGroups, params);
        yield put(GroupActions.dataGroupSuccess(result));
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* getAllGroup() {
    yield takeLatest(Types.GROUP_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(GroupService.getAllGroups, action.filters || {});
        yield put(GroupActions.dataAllGroupSuccess(result));
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* getGroupDetail() {
    yield takeLatest(Types.GROUP_GET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(GroupService.getGroupDetail, action.params.id);
        yield put(GroupActions.getUpdateGroupSuccess(result));
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* createGroup() {
    yield takeLatest(Types.GROUP_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const group = action.params.data;
        yield call(GroupService.createGroup, group);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), group.name);
        history.push(PATHS.GROUP.LIST.path);
        history.go();
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* updateGroup() {
    yield takeLatest(Types.GROUP_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const group = (action.params.data);
        yield call(GroupService.updateGroup, group);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), group.name);
        yield put({ type: Types.GROUP_UPDATE_SUCCESS });
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* deleteGroup() {
    yield takeLatest(Types.GROUP_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GroupService.deleteGroup, action.params.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'));
        yield put({ type: Types.GROUP_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* cloneGroup() {
    yield takeLatest(Types.GROUP_CLONE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GroupService.cloneGroup, action.params.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.cloneSuccess'));
        yield put({ type: Types.GROUP_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* importGroup() {
    yield takeLatest(Types.GROUP_IMPORT_ACTION, Func.sagaWrapper(function* (action) {
        const formData = new FormData();
        formData.append('file', action.params.file);
        formData.append('propertyIds', action.params.propertyIds);
        yield call(GroupService.importGroup, formData);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.200'));
        yield put({ type: Types.GROUP_LIST_ACTION });
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* exportGroup() {
    yield takeLatest(Types.GROUP_EXPORT_ACTION, Func.sagaWrapper(function* (action) {
        const params = action.filters.data;
        if (params) params.culture = i18n.t('exportLang');
        const result = yield call(GroupService.exportGroup, params);
        let fileName = result.headers['x-suggestion-filename'];
        Func.downloadFile(result.data, fileName);
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* exportProductFeed() {
    yield takeLatest(Types.GROUP_EXPORT_PRODUCT_FEED_ACTION, Func.sagaWrapper(function* (action) {
        const params = action.params;
        const result = yield call(GroupService.exportProductFeed, params);
        let fileName = result.headers['x-suggestion-filename'];
        Func.downloadFile(result.data, fileName);
        yield put(GroupActions.exportProductFeedSuccess(result));
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* reindexProduct() {
    yield takeLatest(Types.GROUP_REINDEX_PRODUCT_ACTION, Func.sagaWrapper(function* (action) {
        const params = action?.params;
        yield call(GroupService.reindexProduct, params);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), i18n.t('item.experience.indexSKUs'));
        yield put(GroupActions.reindexProductSuccess());
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

// TRANSLATE
function* createGroupTranslate() {
    yield takeLatest(Types.GROUP_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GroupService.createGroupTranslate, action.group);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.group.translate.languageName);
        yield put({ type: Types.GROUP_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.GROUP_GET_UPDATE_ACTION, params: { id: action.group.id } });
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* updateGroupTranslate() {
    yield takeLatest(Types.GROUP_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GroupService.updateGroupTranslate, action.group);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.group.translate.languageName);
        yield put({ type: Types.GROUP_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.GROUP_GET_UPDATE_ACTION, params: { id: action.group.id } });
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function* deleteGroupTranslate() {
    yield takeLatest(Types.GROUP_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GroupService.deleteGroupTranslate, action.group.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.group.translate.languageName);
        yield put({ type: Types.GROUP_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.GROUP_GET_UPDATE_ACTION, params: { id: action.refreshParams.id } });
    }, errorHandleGroup(Types.GROUP_FAIL)))
}

function errorHandleGroup(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'group');
}

export function* groupSaga() {
    yield all([
        fork(getListGroup),
        fork(createGroup),
        fork(deleteGroup),
        fork(getGroupDetail),
        fork(updateGroup),
        fork(cloneGroup),
        fork(importGroup),
        fork(exportGroup),
        fork(exportProductFeed),
        fork(reindexProduct),
        fork(getAllGroup),
        fork(createGroupTranslate),
        fork(updateGroupTranslate),
        fork(deleteGroupTranslate),
    ])
}
